import dayjs from "dayjs";
import type { AppNotification } from "./types";

export function getNotificationMessage(notification: AppNotification): string {
  if (notification.orderControl === "CA") {
    return `Order ${notification.accessionNumber} has been cancelled (${notification.receivingClinic}).`;
  }
  if (notification.type === "pacs.order.sent") {
    return `Order ${notification.accessionNumber} sent to ${notification.receivingClinic}.`;
  }
  return `Order ${notification.accessionNumber}`;
}

export function formatNotificationTime(iso: string): string {
  const date = dayjs(iso);
  if (!date.isValid()) return "-";

  if (date.isSame(dayjs(), "day")) {
    return `Today, ${date.format("h:mm A")}`;
  }

  return date.format("DD MMMM, h:mm A");
}
